// Unpublished Work © 2026 Deere & Company.

import facebookIcon from '/assets/jd_facebook.svg';
import instagramIcon from '/assets/jd_instagram.svg';
import youtubeIcon from '/assets/jd_youtube.svg';
import xIcon from '/assets/jd_x.svg';
import linkedinIcon from '/assets/jd_linkedin.svg';
import weiboIcon from '/assets/jd_weibo.svg';

export const FOOTER_MAP = {
    'bg-bg': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Поверителност и данни',
                url: 'https://www.deere.bg/bg/poveritelnost-i-danni/'
            },
            {
                id: 'cookie-settings',
                label: 'Настройки за "бисквитки"',
                url: 'https://www.deere.bg/bg/poveritelnost-i-danni/deklaratsia-otnosno-biskvitkite/ '
            },
            {
                label: 'Условия',
                url: 'https://www.deere.bg/bg/poveritelnost-i-danni/uslovia/ '
            },
            {
                label: 'Доставчик',
                url: 'https://www.deere.bg/bg/dostavchik/'
            }
        ],
        copyrightLine: `Авторско право © ${new Date().getFullYear()} Deere & Company. Всички права запазени.`
    },
    'cs-cz': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Prohlaseni o ochrane soukromi',
                url: 'https://www.deere.cz/cs/soukromí-a-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Prohlaseni',
                url: 'https://www.deere.cz/cs/soukromí-a-data/cookie-prohlášení/'
            },
            {
                label: 'Pravni informace',
                url: 'https://www.deere.cz/cs/soukromí-a-data/právní-informace/'
            },
            {
                label: 'Tiraz',
                url: 'https://www.deere.cz/cs/tiraz/'
            },
            {
                label: 'Kontakt',
                url: 'https://www.deere.cz/cs/nase-spolecnost/kontakt/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Vsechna prava vyhrazena.`
    },
    'da-dk': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereDanmark'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereDanmark'
            }
        ],
        utilityLinks: [
            {
                label: 'Brugerbeskyttelse og data',
                url: 'https://www.deere.dk/da/brugerbeskyttelse-og-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Erklæring',
                url: 'https://www.deere.dk/da/brugerbeskyttelse-og-data/cookie-erklæring/'
            },
            {
                label: 'Jura',
                url: 'https://www.deere.dk/da/brugerbeskyttelse-og-data/jura/'
            },
            {
                label: 'Udbyder',
                url: 'https://www.deere.dk/da/udbyder/'
            },
            {
                label: 'Kontakt os',
                url: 'https://www.deere.dk/da/vores-virksomhed/kontakt-os/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Alle rettigheder forbeholdes.`
    },
    'de-at': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereDeutschland/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereDeutschland'
            }
        ],
        utilityLinks: [
            {
                label: 'Datenschutzerklärung',
                url: 'https://www.deere.at/de/datenschutzerklärung/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie-Richtlinie',
                url: 'https://www.deere.at/de/datenschutzerklärung/cookie-richtlinie/'
            },
            {
                label: 'Rechtliche Hinweise',
                url: 'https://www.deere.at/de/datenschutzerklärung/rechtliche-hinweise/'
            },
            {
                label: 'Impressum',
                url: 'https://www.deere.at/de/impressum/'
            },
            {
                label: 'Kontakt',
                url: 'https://www.deere.at/de/unser-unternehmen/kontakt/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Alle Rechte vorbehalten.`
    },
    'de-ch': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereDeutschland/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereDeutschland'
            }
        ],
        utilityLinks: [
            {
                label: 'Datenschutzerklärung',
                url: 'https://www.deere.ch/de/datenschutzerklärung/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie-Richtlinie',
                url: 'https://www.deere.ch/de/datenschutzerklärung/cookie-richtlinie/'
            },
            {
                label: 'Rechtliche Hinweise',
                url: 'https://www.deere.ch/de/datenschutzerklärung/rechtliche-hinweise/'
            },
            {
                label: 'Impressum',
                url: 'https://www.deere.ch/de/impressum/'
            },
            {
                label: 'Kontakt',
                url: 'https://www.deere.ch/de/unser-unternehmen/kontakt/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Alle Rechte vorbehalten.`
    },
    'de-de': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereDeutschland/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereDeutschland'
            },
            {
                iconText: 'LinkedIn icon',
                icon: linkedinIcon,
                url: 'https://www.linkedin.com/company/john-deere'
            }
        ],
        utilityLinks: [
            {
                label: 'Datenschutzerklärung',
                url: 'https://www.deere.de/de/datenschutzerklärung/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie-Richtlinie',
                url: 'https://www.deere.de/de/datenschutzerklärung/cookie-richtlinie/'
            },
            {
                label: 'Rechtliche Hinweise',
                url: 'https://www.deere.de/de/datenschutzerklärung/rechtliche-hinweise/'
            },
            {
                label: 'Impressum',
                url: 'https://www.deere.de/de/impressum/'
            },
            {
                label: 'Kontakt',
                url: 'https://www.deere.de/de/unser-unternehmen/kontakt/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Alle Rechte vorbehalten.`
    },
    'el-gr': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Ιδιωτικό απόρρητο και δεδομένα',
                url: 'https://www.deere.gr/el/privacy-and-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Ρυθμίσεις Cookie',
                url: 'https://www.deere.gr/el/privacy-and-data/cookie-statement/'
            },
            {
                label: 'Όροι χρήσης',
                url: 'https://www.deere.gr/el/privacy-and-data/terms/'
            },
            {
                label: 'Πάροχος',
                url: 'https://www.deere.gr/el/provider/'
            },
            {
                label: 'Επικοινωνία',
                url: 'https://www.deere.gr/el/our-company/contact-us/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Με επιφύλαξη παντός δικαιώματος.`
    },
    'en-au': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereAUNZ'
            },
            {
                iconText: 'Twitter icon',
                icon: xIcon,
                url: 'https://twitter.com/johndeereAUNZ'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereAU'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacy and Data',
                url: 'https://www.deere.com.au/en/privacy-and-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Statement',
                url: 'https://www.deere.com.au/en/privacy-and-data/cookie-statement/'
            },
            {
                label: 'Terms',
                url: 'https://www.deere.com.au/en/privacy-and-data/terms/'
            },
            {
                label: 'Accessibility',
                url: 'https://www.deere.com.au/en/privacy-and-data/accessibility/'
            },
            {
                label: 'Contact Us',
                url: 'https://www.deere.com.au/en/our-company/contact-us/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. All Rights Reserved.`
    },
    'en-nz': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereAUNZ'
            },
            {
                iconText: 'Twitter icon',
                icon: xIcon,
                url: 'https://twitter.com/johndeereAUNZ'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereAU'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacy and Data',
                url: 'https://www.deere.co.nz/en/privacy-and-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Statement',
                url: 'https://www.deere.co.nz/en/privacy-and-data/cookie-statement/'
            },
            {
                label: 'Terms',
                url: 'https://www.deere.co.nz/en/privacy-and-data/terms/'
            },
            {
                label: 'Accessibility',
                url: 'https://www.deere.co.nz/en/privacy-and-data/accessibility/'
            },
            {
                label: 'Contact Us',
                url: 'https://www.deere.co.nz/en/our-company/contact-us/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. All Rights Reserved.`
    },
    'en-ca': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'http://www.facebook.com/JohnDeereUSCA'
            },
            {
                iconText: 'Twitter icon',
                icon: xIcon,
                url: 'https://twitter.com/JohnDeere'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeere'
            },
            {
                iconText: 'LinkedIn icon',
                icon: linkedinIcon,
                url: 'https://www.linkedin.com/company/john-deere'
            },
            {
                iconText: 'Instagram',
                icon: instagramIcon,
                url: 'http://instagram.com/johndeere'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacy and Data',
                url: 'https://www.deere.ca/en/privacy-and-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Statement',
                url: 'https://www.deere.ca/en/privacy-and-data/cookie-statement/'
            },
            {
                label: 'Terms of Use',
                url: 'https://www.deere.ca/en/privacy-and-data/terms/'
            },
            {
                label: 'Accessibility',
                url: 'https://www.deere.ca/en/privacy-and-data/accessibility/'
            },
            {
                label: 'Contact Us',
                url: 'https://www.deere.ca/en/our-company/contact-us/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. All Rights Reserved.`
    },
    'en-us': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'http://www.facebook.com/JohnDeereUSCA'
            },
            {
                iconText: 'Twitter icon',
                icon: xIcon,
                url: 'https://twitter.com/JohnDeere'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeere'
            },
            {
                iconText: 'LinkedIn icon',
                icon: linkedinIcon,
                url: 'https://www.linkedin.com/company/john-deere'
            },
            {
                iconText: 'Instagram',
                icon: instagramIcon,
                url: 'http://instagram.com/johndeere'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacy and Data',
                url: 'https://www.deere.com/en/privacy-and-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Statement',
                url: 'https://www.deere.com/en/privacy-and-data/cookie-statement/'
            },
            {
                label: 'Terms of Use',
                url: 'https://www.deere.com/en/privacy-and-data/terms/'
            },
            {
                label: 'Accessibility',
                url: 'https://www.deere.com/en/privacy-and-data/accessibility/'
            },
            {
                label: 'Contact Us',
                url: 'https://www.deere.com/en/our-company/contact-us/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. All Rights Reserved.`
    },
    'en-in': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/johndeereindia/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/johndeereindia'
            },
            {
                iconText: 'LinkedIn icon',
                icon: linkedinIcon,
                url: 'https://www.linkedin.com/company/john-deere/'
            },
            {
                iconText: 'Instagram',
                icon: instagramIcon,
                url: 'https://instagram.com/johndeereindia?igshid=joe0misyo2nv'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacy and Data',
                url: 'https://www.deere.co.in/en/privacy-and-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Statement',
                url: 'https://www.deere.co.in/en/privacy-and-data/cookie-statement/'
            },
            {
                label: 'Terms of Use',
                url: 'https://www.deere.co.in/en/privacy-and-data/terms/'
            },
            {
                label: 'Contact Us',
                url: 'https://www.deere.co.in/en/our-company/contact-us/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. All Rights Reserved.`
    },
    'en-th': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereThailand'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/johndeerethailand'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacy and Data',
                url: 'https://www.deere.co.th/en/privacy-and-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Statement',
                url: 'https://www.deere.co.th/en/privacy-and-data/cookie-statement/'
            },
            {
                label: 'Terms of Use',
                url: 'https://www.deere.co.th/en/privacy-and-data/terms/'
            },
            {
                label: 'Contact Us',
                url: 'https://www.deere.co.th/en/our-company/contact-us/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. All Rights Reserved.`
    },
    'en-lu': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Privacy and Data',
                url: 'https://www.deere.lu/en/privacy-and-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Statement',
                url: 'https://www.deere.lu/en/privacy-and-data/cookie-statement/'
            },
            {
                label: 'Terms of Use',
                url: 'https://www.deere.lu/en/privacy-and-data/terms/'
            },
            {
                label: 'Contact Us',
                url: 'https://www.deere.lu/en/our-company/contact-us/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. All Rights Reserved.`
    },
    'en-gb': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereUKIE'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereUKIE'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacy and Data',
                url: 'https://www.deere.co.uk/en/privacy-and-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Statement',
                url: 'https://www.deere.co.uk/en/privacy-and-data/cookie-statement/'
            },
            {
                label: 'Terms of Use',
                url: 'https://www.deere.co.uk/en/privacy-and-data/terms/'
            },
            {
                label: 'Tax Strategy',
                url: 'https://www.deere.co.uk/en/legal/tax-strategy/'
            },
            {
                label: 'Provider',
                url: 'https://www.deere.co.uk/en/provider/'
            },
            {
                label: 'Contact Us',
                url: 'https://www.deere.co.uk/en/our-company/contact-us/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. All Rights Reserved.`
    },
    'en-ie': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereUKIE'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereUKIE'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacy and Data',
                url: 'https://www.deere.co.uk/en/privacy-and-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie Statement',
                url: 'https://www.deere.co.uk/en/privacy-and-data/cookie-statement/'
            },
            {
                label: 'Terms of Use',
                url: 'https://www.deere.co.uk/en/privacy-and-data/terms/'
            },
            {
                label: 'Tax Strategy',
                url: 'https://www.deere.co.uk/en/legal/tax-strategy/'
            },
            {
                label: 'Provider',
                url: 'https://www.deere.co.uk/en/provider/'
            },
            {
                label: 'Contact Us',
                url: 'https://www.deere.co.uk/en/our-company/contact-us/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. All Rights Reserved.`
    },
    'es-es': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereEspana'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereEspana'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacidad y Protección de Datos',
                url: 'https://www.deere.es/es/privacidad-y-protección-de-datos/'
            },
            {
                id: 'cookie-settings',
                label: 'Política de Cookies',
                url: 'https://www.deere.es/es/privacidad-y-protección-de-datos/política-de-cookies/'
            },
            {
                label: 'Términos de Uso',
                url: 'https://www.deere.es/es/privacidad-y-protección-de-datos/aviso-legal/'
            },
            {
                label: 'Información general',
                url: 'https://www.deere.es/es/información-general'
            },
            {
                label: 'Contáctenos',
                url: 'https://www.deere.es/es/nuestra-compañía/contacte-con-nosotros/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Todos los derechos reservados`
    },
    'es-ar': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereArgentina/'
            },
            {
                iconText: 'Twitter icon',
                icon: xIcon,
                url: 'https://twitter.com/JohnDeereArg'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereArgentina'
            },
            {
                iconText: 'Instagram',
                icon: instagramIcon,
                url: 'https://www.instagram.com/johndeereargentina'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacidad de datos',
                url: 'https://www.deere.com.ar/es/privacidad-y-protección-de-datos/'
            },
            {
                id: 'cookie-settings',
                label: 'Política de Cookies',
                url: 'https://www.deere.com.ar/es/privacidad-y-protección-de-datos/política-de-cookies/'
            },
            {
                label: 'Aviso Legal',
                url: 'https://www.deere.com.ar/es/privacidad-y-protección-de-datos/aviso-legal/'
            },
            {
                label: 'Contacto',
                url: 'https://www.deere.com.ar/es/nuestra-compañía/contáctenos/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Reservados todos los derechos.`
    },
    'es-mx': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereMexico'
            },
            {
                iconText: 'Twitter icon',
                icon: xIcon,
                url: 'https://twitter.com/johndeeremexico'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereMexico'
            },
            {
                iconText: 'Instagram',
                icon: instagramIcon,
                url: 'https://www.instagram.com/JohnDeereMexico/'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacidad y datos',
                url: 'https://www.deere.com.mx/es/privacidad-y-protección-de-datos/'
            },
            {
                id: 'cookie-settings',
                label: 'Política de cookies',
                url: 'https://www.deere.com.mx/es/privacidad-y-protección-de-datos/política-de-cookies/'
            },
            {
                label: 'Aviso legal',
                url: 'https://www.deere.com.mx/es/privacidad-y-protección-de-datos/aviso-legal/'
            },
            {
                label: 'Contáctenos',
                url: 'https://www.deere.com.mx/es/contacte-a-john-deere/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Todos los derechos reservados.`
    },
    'et-ee': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Privaatsus ja andmed',
                url: 'https://www.deere.ee/et/privaatsus-ja-andmed/'
            },
            {
                id: 'cookie-settings',
                label: 'Küpsiste sätted',
                url: 'https://www.deere.ee/et/privaatsus-ja-andmed/kupsiseavaldus/'
            },
            {
                label: 'Kasutustingimused',
                url: 'https://www.deere.ee/et/privaatsus-ja-andmed/terminid/'
            },
            {
                label: 'Võtke meiega ühendust',
                url: 'https://www.deere.ee/et/meie-ettevote/kontakt/'
            },
            {
                label: 'Teenusepakkuja',
                url: 'https://www.deere.ee/et/teenusepakkuja/'
            }
        ],
        copyrightLine: `Autorõigus © ${new Date().getFullYear()} Deere & Company. Kõik õigused kaitstud`
    },
    'fi-fi': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereSuomi/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/channel/UCSRscVN8q1_5l29_5XbQ9jQ'
            },
            {
                iconText: 'LinkedIn icon',
                icon: linkedinIcon,
                url: 'https://www.linkedin.com/company/john-deere/'
            }
        ],
        utilityLinks: [
            {
                label: 'Tietoturvakäytäntö',
                url: 'https://www.deere.fi/fi/tietoturvakäytäntö/'
            },
            {
                id: 'cookie-settings',
                label: 'Evästeet',
                url: 'https://www.deere.fi/fi/tietoturvakäytäntö/evästeet/'
            },
            {
                label: 'Käyttöehdot',
                url: 'https://www.deere.fi/fi/käyttöehdot/'
            },
            {
                label: 'Palveluntarjoaja',
                url: 'https://www.deere.fi/fi/palveluntarjoaja/'
            },
            {
                label: 'Ota yhteyttä',
                url: 'https://www.deere.fi/fi/yhtiömme/ota-yhteyttä/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Kaikki oikeudet pidätetään.`
    },
    'fr-ca': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'http://www.facebook.com/JohnDeereUSCA'
            },
            {
                iconText: 'Twitter icon',
                icon: xIcon,
                url: 'https://twitter.com/JohnDeere'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeere'
            },
            {
                iconText: 'LinkedIn icon',
                icon: linkedinIcon,
                url: 'https://www.linkedin.com/company/john-deere'
            },
            {
                iconText: 'Instagram',
                icon: instagramIcon,
                url: 'http://instagram.com/johndeere'
            }
        ],
        utilityLinks: [
            {
                label: 'Protection des données privées',
                url: 'https://www.deere.ca/fr/protection-des-donn%C3%A9es-priv%C3%A9es/'
            },
            {
                id: 'cookie-settings',
                label: 'Gestion des cookies',
                url: 'https://www.deere.ca/fr/protection-des-donn%C3%A9es-priv%C3%A9es/gestion-des-cookies/'
            },
            {
                label: 'Mentions Légales',
                url: 'https://www.deere.ca/fr/protection-des-donn%C3%A9es-priv%C3%A9es/mentions-l%C3%A9gales/'
            },
            {
                label: 'Accessibilité',
                url: 'https://www.deere.ca/fr/protection-des-donn%C3%A9es-priv%C3%A9es/accessibilit%C3%A9/'
            },
            {
                label: 'Communiquer avec nous',
                url: 'https://www.deere.ca/fr/notre-entreprise/communiquer-avec-nous/'
            }
        ],
        copyrightLine: `Droit d’auteur © ${new Date().getFullYear()} Deere & Company. Tous droits réservés.`
    },
    'fr-be': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/CofabelJohnDeereDealer/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/channel/UCsVgxQ6VaidxDIFa3lY5zCg'
            }
        ],
        utilityLinks: [
            {
                label: 'Protection des données privées',
                url: 'https://www.deere.be/fr/protection-des-données-privées/'
            },
            {
                id: 'cookie-settings',
                label: 'Gestion des cookies',
                url: 'https://www.deere.be/fr/protection-des-données-privées/gestion-des-cookies/'
            },
            {
                label: 'Mentions Légales',
                url: 'https://www.deere.be/fr/protection-des-données-privées/mentions-légales/'
            },
            {
                label: 'Editeur et hébergement',
                url: 'https://www.deere.be/fr/editeur-et-hébergement/'
            },
            {
                label: 'Contactez-nous',
                url: 'https://www.deere.be/fr/notre-compagnie/contactez-nous/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Tous droits réservés`
    },
    'fr-fr': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereFrance'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereFrance'
            }
        ],
        utilityLinks: [
            {
                label: 'Protection des données privées',
                url: 'https://www.deere.fr/fr/protection-des-données-privées/'
            },
            {
                id: 'cookie-settings',
                label: 'Gestion des cookies',
                url: 'https://www.deere.fr/fr/protection-des-données-privées/gestion-des-cookies/'
            },
            {
                label: 'Mentions Légales',
                url: 'https://www.deere.fr/fr/protection-des-données-privées/mentions-légales/'
            },
            {
                label: 'Editeur et hébergement',
                url: 'https://www.deere.fr/fr/editeur-et-hébergement/'
            },
            {
                label: 'Contactez-nous',
                url: 'https://www.deere.fr/fr/notre-compagnie/contactez-nous/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Tous droits réservés`
    },
    'fr-ch': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereFrance'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereFrance'
            }
        ],
        utilityLinks: [
            {
                label: 'Protection des données privées',
                url: 'https://www.deere.ch/fr/protection-des-données-privées/'
            },
            {
                id: 'cookie-settings',
                label: 'Gestion des cookies',
                url: 'https://www.deere.ch/fr/protection-des-données-privées/gestion-des-cookies/'
            },
            {
                label: 'Mentions Légales',
                url: 'https://www.deere.ch/fr/protection-des-données-privées/mentions-légales/'
            },
            {
                label: 'Editeur et hébergement',
                url: 'https://www.deere.ch/fr/editeur-et-hébergement/'
            },
            {
                label: 'Contactez-nous',
                url: 'https://www.deere.ch/fr/notre-compagnie/contactez-nous/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Tous droits réservés`
    },
    'hr-hr': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Privatnost i podaci',
                url: 'https://www.deere.hr/hr/privatnost-i-podaci/ '
            },
            {
                id: 'cookie-settings',
                label: 'Postavke kolačića',
                url: 'https://www.deere.hr/hr/privatnost-i-podaci/izjava-o-kolacicima/ '
            },
            {
                label: 'Pravna Obavijest',
                url: 'https://www.deere.hr/hr/privatnost-i-podaci/pravna-obavijest/'
            },
            {
                label: 'Pruzatelj Usluge',
                url: 'https://www.deere.hr/hr/pruzatelj-usluge/'
            },
            {
                label: 'Privacy Complaint Form',
                url: 'https://www.deere.hr/hr/privatnost-i-podaci/privacy-complaint-form/ '
            },
            {
                label: 'Kontaktirajte nas',
                url: 'https://www.deere.hr/hr/nasa-tvrtka/kontaktirajte-nas/'
            }
        ],
        copyrightLine: `Autorsko pravo© ${new Date().getFullYear()} Deere & Company. Sva prava pridržana.`
    },
    'hu-hu': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Adatvédelem és adatok',
                url: 'https://www.deere.hu/hu/adatvedelem-es-adatok/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie kkel kapcsolatos nyilatkozat',
                url: 'https://www.deere.hu/hu/adatvedelem-es-adatok/cookie-hasznalattal-kapcsolatos-nyilatkozat/'
            },
            {
                label: 'Feltételek',
                url: 'https://www.deere.hu/hu/adatvedelem-es-adatok/feltetelek/ '
            },
            {
                label: 'Privacy complaint form',
                url: 'https://www.deere.hu/hu/adatvedelem-es-adatok/privacy-complaint-form/'
            },
            {
                label: 'Elérhetőségek',
                url: 'https://www.deere.hu/hu/cegunkrol/kapcsolatfelvetel/'
            }
        ],
        copyrightLine: `Szerzői jog © ${new Date().getFullYear()} Deere & Company. Minden jog fenntartva.`
    },
    'it-it': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereItaliana'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereItaly'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacy e Dati',
                url: 'https://www.deere.it/it/privacy-e-dati/'
            },
            {
                id: 'cookie-settings',
                label: 'Politica sui Cookie',
                url: 'https://www.deere.it/it/privacy-e-dati/politica-sui-cookie/'
            },
            {
                label: 'Informazioni Legali',
                url: 'https://www.deere.it/it/privacy-e-dati/informazioni-legali/'
            },
            {
                label: 'Provider',
                url: 'https://www.deere.it/it/provider/'
            },
            {
                label: 'Per Contattarci',
                url: 'https://www.deere.it/it/la-compagnia/per-contattarci'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Tutti i diritti riservati`
    },
    'lt-lt': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Privatumas ir duomenys',
                url: 'https://www.deere.lt/lt/privatumas-ir-duomenys/'
            },
            {
                id: 'cookie-settings',
                label: 'Slapuko parametrai',
                url: 'https://www.deere.lt/lt/privatumas-ir-duomenys/pranesimas-apie-slapukus/'
            },
            {
                label: 'Naudojimo sąlygos',
                url: 'https://www.deere.lt/lt/privatumas-ir-duomenys/salygos/'
            },
            {
                label: 'Skundo dėl privatumo forma',
                url: 'https://www.deere.lt/lt/privatumas-ir-duomenys/privacy-complaint-form/ '
            },
            {
                label: 'Tiekėjas',
                url: 'https://www.deere.lt/lt/tiekejas/'
            },
            {
                label: 'Susisiekite su mumis',
                url: 'https://www.deere.lt/lt/musu-bendrove/susisiekite-su-mumis/'
            }
        ],
        copyrightLine: `Autorių teisės © ${new Date().getFullYear()} „Deere & Company“ Visos teisės saugomos.`
    },
    'lv-lv': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Privātums un dati',
                url: 'https://www.deere.lv/lv/privatums-un-dati/ '
            },
            {
                id: 'cookie-settings',
                label: 'Sīkfailu iestatījumi',
                url: 'https://www.deere.lv/lv/privatums-un-dati/pazinojums-par-sikfailiem/ '
            },
            {
                label: 'Lietošanas noteikumi',
                url: 'https://www.deere.lv/lv/privatums-un-dati/noteikumi/'
            },
            {
                label: 'Privātuma sūdzību veidlapa',
                url: 'https://www.deere.lv/lv/privatums-un-dati/privacy-complaint-form/'
            },
            {
                label: 'Pakalpojumu sniedzējs',
                url: 'https://www.deere.lv/lv/pakalpojumu-sniedzejs/'
            },
            {
                label: 'Sazinieties ar mums',
                url: 'https://www.deere.lv/lv/musu-uznemums/sazinieties-ar-mums/'
            }
        ],
        copyrightLine: `Autortiesības © ${new Date().getFullYear()} Deere & Company. Visas tiesības paturētas.`
    },
    'nl-nl': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereNederland'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereNetherlands'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacy en Data',
                url: 'https://www.deere.nl/nl/privacy-en-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie-instellingen',
                url: 'https://www.deere.nl/nl/privacy-en-data/cookieinstellingen/'
            },
            {
                label: 'Juridisch',
                url: 'https://www.deere.nl/nl/privacy-en-data/juridisch/'
            },
            {
                label: 'Impressum',
                url: 'https://www.deere.nl/nl/impressum/'
            },
            {
                label: 'Contact opnemen',
                url: 'https://www.deere.nl/nl/ons-bedrijf/contact/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Alle rechten voorbehouden`
    },
    'no-no': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Personvern og data',
                url: 'https://www.deere.no/no/sekretesspolicy-og-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Erklæring om informasjonskapsler',
                url: 'https://www.deere.no/no/sekretesspolicy-og-data/cookies-inställningar/'
            },
            {
                label: 'Brukervilkår',
                url: 'https://www.deere.no/no/sekretesspolicy-og-data/juridisk/'
            },
            {
                label: 'Impressum',
                url: 'https://www.deere.no/no/impressum/'
            },
            {
                label: 'Kontakt oss',
                url: 'https://www.deere.no/no/vår-bedrift/kontakt-oss/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Med enerett.`
    },
    'pl-pl': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeerePolska/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeerePoland'
            }
        ],
        utilityLinks: [
            {
                label: 'Ochrona prywatności',
                url: 'https://www.deere.pl/pl/ochrona-prywatności/'
            },
            {
                id: 'cookie-settings',
                label: 'Oświadczenie o plikach cookie',
                url: 'https://www.deere.pl/pl/ochrona-prywatności/oświadczenie-o-plikach-cookie/'
            },
            {
                label: 'Informacje prawne',
                url: 'https://www.deere.pl/pl/ochrona-prywatności/informacje-prawne/'
            },
            {
                label: 'Dostawca',
                url: 'https://www.deere.pl/pl/dostawca'
            },
            {
                label: 'Kontakt',
                url: 'https://www.deere.pl/pl/o-firmie/kontakt/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Wszelkie prawa zastrzeżone.`
    },
    'pt-pt': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Privacidade e Dados',
                url: 'https://www.deere.pt/pt/privacidade-e-dados/'
            },
            {
                id: 'cookie-settings',
                label: 'Declaração de Cookies',
                url: 'https://www.deere.pt/pt/privacidade-e-dados/política-de-cookies/'
            },
            {
                label: 'Aviso Legal',
                url: 'https://www.deere.pt/pt/privacidade-e-dados/aviso-legal/'
            },
            {
                label: 'Informação geral',
                url: 'https://www.deere.pt/pt/informação-geral/'
            },
            {
                label: 'Contacte connosco',
                url: 'https://www.deere.pt/pt/a-nossa-empresa/contacte-connosco/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Todos os direitos reservados`
    },
    'pt-br': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/John-Deere-981256808600879'
            },
            {
                iconText: 'Twitter icon',
                icon: xIcon,
                url: 'https://www.twitter.com/JohnDeereBrasil'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'http://www.youtube.com/JohnDeereBrasil'
            },
            {
                iconText: 'LinkedIn icon',
                icon: linkedinIcon,
                url: 'https://www.linkedin.com/company/john-deere '
            },
            {
                iconText: 'Instagram',
                icon: instagramIcon,
                url: 'https://instagram.com/johndeerebrasil?igshid=1jdjwaiiahjnd'
            }
        ],
        utilityLinks: [
            {
                label: 'Privacidade e dados',
                url: 'https://www.deere.com.br/pt/privacidade-e-dados/'
            },
            {
                id: 'cookie-settings',
                label: 'Política de Cookies',
                url: 'https://www.deere.com.br/pt/privacidade-e-dados/política-de-cookies/'
            },
            {
                label: 'Aviso legal',
                url: 'https://www.deere.com.br/pt/privacidade-e-dados/aviso-legal/'
            },
            {
                label: 'Fale conosco',
                url: 'https://www.deere.com.br/pt/a-nossa-empresa/contato/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Todos os direitos reservados`
    },
    'ro-ro': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Confidenţialitate şi date',
                url: 'https://www.deere.ro/ro/confidentialitate-si-date/'
            },
            {
                id: 'cookie-settings',
                label: 'Setări cookie',
                url: 'https://www.deere.ro/ro/confidentialitate-si-date/declaratie-privind-modulele-cookie/'
            },
            {
                label: 'Termeni de utilizare',
                url: 'https://www.deere.ro/ro/confidentialitate-si-date/prevederi-legale/'
            },
            {
                label: 'Contactaţi-ne',
                url: 'https://www.deere.ro/ro/compania-noastra/contactati-ne/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Toate drepturile rezervate.`
    },
    'ru-ru': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereRussia/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereRussia?ob=0&feature=results_main'
            }
        ],
        utilityLinks: [
            {
                label: 'Политика конфиденциальности данных',
                url: 'https://www.deere.ru/ru/Политика-конфиденциальности-данных/'
            },
            {
                id: 'cookie-settings',
                label: 'Заявление о файлах cookie',
                url: 'https://www.deere.ru/ru/Политика-конфиденциальности-данных/настройки-cookies/'
            },
            {
                label: 'Правовые аспекты',
                url: 'https://www.deere.ru/ru/Политика-конфиденциальности-данных/правовые-аспекты/'
            },
            {
                label: 'Поставщик',
                url: 'https://www.deere.ru/ru/источник-информации/'
            },
            {
                label: 'Контакты',
                url: 'https://www.deere.ru/ru/наша-компания/контакты/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Все права защищены.`
    },
    'ru-ua': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereUkraine/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereUkraine'
            }
        ],
        utilityLinks: [
            {
                label: 'Политика конфиденциальности данных',
                url: 'https://www.deere.ua/ru/Политика-конфиденциальности-данных/'
            },
            {
                id: 'cookie-settings',
                label: 'Заявление о файлах cookie',
                url: 'https://www.deere.ua/ru/Политика-конфиденциальности-данных/Настройки-cookies/'
            },
            {
                label: 'Правовые аспекты',
                url: 'https://www.deere.ua/ru/Политика-конфиденциальности-данных/юридичний'
            },
            {
                label: 'Поставщик',
                url: 'https://www.deere.ua/ru/источник-информации/'
            },
            {
                label: 'Контакты',
                url: 'https://www.deere.ua/ru/наша-компания/контакты/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Все права защищены.`
    },
    'sk-sk': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Súkromie a údaje',
                url: 'https://www.deere.sk/sk/sukromie-a-udaje/'
            },
            {
                id: 'cookie-settings',
                label: 'Vyhlasenie o suboroch cookie',
                url: 'https://www.deere.sk/sk/sukromie-a-udaje/vyhlasenie-o-suboroch-cookie/ '
            },
            {
                label: 'Zmluvne podmienky',
                url: 'https://www.deere.sk/sk/sukromie-a-udaje/zmluvne-podmienky/ '
            },
            {
                label: 'Poskytovateľ ',
                url: 'https://www.deere.sk/sk/Poskytovatel/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Všetky práva vyhradené.`
    },
    'sr-rs': {
        socialLinks: [],
        utilityLinks: [
            {
                label: 'Privatnost i podaci',
                url: 'https://www.deere.rs/sr/privatnost-i-podaci/'
            },
            {
                id: 'cookie-settings',
                label: 'Podešavanja za kolačić',
                url: 'https://www.deere.rs/sr/privatnost-i-podaci/izjava-o-kolacicima/'
            },
            {
                label: 'Uslovi korišćenja',
                url: 'https://www.deere.rs/sr/privatnost-i-podaci/uslovi/'
            },
            {
                label: 'Kontaktirajte nas',
                url: 'https://www.deere.rs/sr/nasa-kompanija/kontaktirajte-nas/'
            },
            {
                label: 'Provajder',
                url: 'https://www.deere.rs/sr/provajder/'
            }
        ],
        copyrightLine: `Autorska prava © ${new Date().getFullYear()} Deere & kompanija. Sva prava zadržana.`
    },
    'sv-se': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereSverige/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/johndeeresverige'
            }
        ],
        utilityLinks: [
            {
                label: 'Datasekretess',
                url: 'https://www.deere.se/sv/sekretesspolicy-och-data/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookiepolicy',
                url: 'https://www.deere.se/sv/sekretesspolicy-och-data/cookies-inställningar/'
            },
            {
                label: 'Juridik',
                url: 'https://www.deere.se/sv/sekretesspolicy-och-data/juridik/'
            },
            {
                label: 'Impressum',
                url: 'https://www.deere.se/sv/impressum/'
            },
            {
                label: 'Kontakta oss',
                url: 'https://www.deere.se/sv/vårt-företag/kontakta-oss/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Med ensamrätt`
    },
    'th-th': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereThailand'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/johndeerethailand'
            }
        ],
        utilityLinks: [
            {
                label: 'ความเป็นส่วนตัวและข้อมูล',
                url: 'https://www.deere.co.th/th/ความเป็นส่วนตัวและข้อมูล/'
            },
            {
                id: 'cookie-settings',
                label: 'การตั้งค่าคุกกี้',
                url: 'https://www.deere.co.th/th/ความเป็นส่วนตัวและข้อมูล/การตั้งค่าคุกกี้/'
            },
            {
                label: 'ข้อมูลทางกฎหมาย',
                url: 'https://www.deere.co.th/th/ความเป็นส่วนตัวและข้อมูล/ข้อมูลทางกฎหมาย/'
            },
            {
                label: 'ติดต่อเรา',
                url: 'https://www.deere.co.th/th/บริษัทของเรา/ติดต่อเรา/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. All Rights Reserved.`
    },
    'tr-tr': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/johndeereturkey/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/channel/UC9t3GpzSeACSpUiCn0aKP3g'
            }
        ],
        utilityLinks: [
            {
                label: 'Gizlilik Politikası',
                url: 'https://www.deere.com.tr/tr/gizlilik-politikası/'
            },
            {
                id: 'cookie-settings',
                label: 'Tanımlama Bilgisi Beyanı',
                url: 'https://www.deere.com.tr/tr/gizlilik-politikası/tanımlama-bilgisi-beyanı/'
            },
            {
                label: 'Yasal',
                url: 'https://www.deere.com.tr/tr/gizlilik-politikası/yasal/'
            },
            {
                label: 'Dane Firmy',
                url: 'https://www.deere.com.tr/tr/dane-firmy/'
            },
            {
                label: 'Bize ulaşın',
                url: 'https://www.deere.com.tr/tr/şirketimiz/bize-ulaşın/'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Tüm Hakları Saklıdır`
    },
    'uk-ua': {
        socialLinks: [
            {
                iconText: 'Facebook icon',
                icon: facebookIcon,
                url: 'https://www.facebook.com/JohnDeereUkraine/'
            },
            {
                iconText: 'YouTube icon',
                icon: youtubeIcon,
                url: 'https://www.youtube.com/user/JohnDeereUkraine'
            }
        ],
        utilityLinks: [
            {
                label: 'Політика конфіденційності даних',
                url: 'https://www.deere.ua/uk/Политика-конфиденциальности-данных/'
            },
            {
                id: 'cookie-settings',
                label: 'Cookie заява',
                url: 'https://www.deere.ua/uk/Политика-конфиденциальности-данных/cookie-заяву/'
            },
            {
                label: 'Артикул',
                url: 'https://www.deere.ua/uk/Политика-конфиденциальности-данных/артикул/'
            },
            {
                label: 'Постачальник',
                url: 'https://www.deere.ua/uk/джерело-інформації/'
            },
            {
                label: 'Контакти',
                url: 'https://www.deere.ua/uk/наша-компанія/звернутися-до-нас/'
            },
            {
                label: 'Політика використання додатків ',
                url: 'https://www.deere.ua/uk/%D0%BD%D0%B0%D1%88%D0%B0-%D0%BA%D0%BE%D0%BC%D0%BF%D0%B0%D0%BD%D1%96%D1%8F/%D0%BF%D1%80%D0%BE-%D0%BD%D0%B0%D1%81/%D1%81%D0%BF%D1%96%D0%B2%D0%BF%D1%80%D0%B0%D1%86%D1%8F/jd-%D0%B4%D0%BE%D0%B4%D0%B0%D1%82%D0%BA%D0%B8.html'
            }
        ],
        copyrightLine: `Copyright © ${new Date().getFullYear()} Deere & Company. Всі права захищені.`
    },
    'zh-cn': {
        socialLinks: [
            {
                iconText: 'Weibo',
                icon: weiboIcon,
                url: 'https://www.weibo.com/johndeere'
            }
        ],
        utilityLinks: [
            {
                label: '隐私与数据',
                url: 'https://www.deere.com.cn/zh/隐私及数据/'
            },
            {
                label: '设置修改',
                url: 'https://www.deere.com.cn/zh/隐私及数据/法律/'
            },
            {
                id: 'cookie-settings',
                label: 'cookie声明',
                url: 'https://www.deere.com.cn/zh/隐私及数据/cookie声明/'
            },
            {
                label: '联系我们',
                url: 'https://www.deere.com.cn/zh/公司信息/联系我们/'
            }
        ],
        copyrightLine: `版权所有 © ${new Date().getFullYear()} 年迪尔公司。保留所有权利 工信部备案：京ICP备14037508号-2`
    }
};

export const DEFAULT_COUNTRIES = {
    bg: 'bg',
    cs: 'cz',
    da: 'dk',
    de: 'de',
    el: 'gr',
    en: 'us',
    es: 'es',
    et: 'ee',
    fi: 'fi',
    fr: 'fr',
    hr: 'hr',
    hu: 'hu',
    it: 'it',
    lt: 'lt',
    lv: 'lv',
    nl: 'nl',
    no: 'no',
    pl: 'pl',
    pt: 'br',
    ro: 'ro',
    ru: 'ru',
    sk: 'sk',
    sr: 'rs',
    sv: 'se',
    th: 'th',
    tr: 'tr',
    uk: 'ua',
    zh: 'cn'
};
